import { render, staticRenderFns } from "./MergeOrderReferenceButton.vue?vue&type=template&id=ba37e60e&"
import script from "./MergeOrderReferenceButton.vue?vue&type=script&lang=js&"
export * from "./MergeOrderReferenceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports